import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import EyebrowPiercingImage from '../../Assets/Piercing Services/eye brow piercing (2).png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function EyebrowPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Eyebrow Piercing UAE | 150-175 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Eyebrow Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Eyebrow Piercing 150-175 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={EyebrowPiercingImage} alt="Eyebrow Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Eyebrow Piercing</h3>

          <p>
            Make a confident and stylish statement with our professional eyebrow piercing services in the UAE, available at an affordable price range of 150–175 AED. Eyebrow piercing is a bold and expressive choice that adds a sharp, modern edge to your overall appearance. Positioned along the natural curve of the eyebrow, this piercing is perfect for individuals who want to showcase their personality and stand out with a strong, eye-catching look. Whether you prefer a subtle barbell or a more striking jewelry style, our expert specialists ensure precise placement that enhances your facial features and complements your unique style.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and comfort are our highest priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each eyebrow piercing with accuracy and care. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience for every client. Our goal is to provide a quick, efficient, and pain-minimized procedure so you can enjoy your new piercing with confidence.
          </p>

          <p>
            Eyebrow piercing is ideal for those who want to express individuality with a bold yet stylish accessory. It is a popular choice among trendsetters and fashion enthusiasts who appreciate a distinctive look that stands out without being overly complex. Our specialists take the time to understand your preferences and guide you in choosing the best placement and jewelry style, ensuring that your piercing aligns perfectly with your desired aesthetic.
          </p>

          <p>
            The procedure is typically completed within minutes, making it convenient even for those with busy schedules. Our team uses advanced techniques designed to reduce discomfort and promote faster healing, allowing you to return to your routine quickly. We also provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a comfortable healing process.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and well cared for throughout their visit. We understand that getting a facial piercing can feel intimidating, especially for first-time clients, and our friendly staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a positive and comfortable experience.
          </p>

          <p>
            Aftercare is a crucial part of maintaining your eyebrow piercing, and we provide detailed instructions to help you care for it properly. Our specialists will guide you on cleaning routines, recommended products, and precautions to avoid infection or irritation. With proper aftercare, your eyebrow piercing will heal smoothly and remain a long-lasting addition to your style.
          </p>

          <p>
            Our eyebrow piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden charges. Booking your appointment is simple and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted eyebrow piercing services in the UAE for a safe, hygienic, and professional experience. With experienced specialists, precise techniques, and a strong focus on customer satisfaction, we help you achieve a bold and confident look effortlessly. Book your eyebrow piercing appointment today and express your individuality with style, precision, and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Eyebrow Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default EyebrowPiercing;